var _path, _ellipse, _ellipse2, _ellipse3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.211 11.537.006-.007.005-.008a6.618 6.618 0 0 0 1.144-4.573v-.004c-.398-3.174-3.024-5.71-6.213-5.909h-.001a6.727 6.727 0 0 0-7.15 7.151v.003c.1 1.52.855 2.982 1.931 4.1 1.076 1.12 2.512 1.934 4.027 2.11l.008.002a7.159 7.159 0 0 0 4.09-.833.48.48 0 0 1 .242 0c.001.001 0 0 0 0 .166.083.394.207.647.345l.04.021c.262.143.546.297.785.416.302.151.623.061.82-.094a.735.735 0 0 0 .239-.851 50.28 50.28 0 0 0-.258-.688c-.129-.336-.253-.661-.333-.903l-.011-.034-.016-.032c-.053-.106-.026-.179-.002-.212Z",
    fill: "#fff",
    stroke: "#0085FF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.858,
    cy: 7.97,
    rx: 0.745,
    ry: 0.692,
    fill: "#0085FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.685,
    cy: 7.97,
    rx: 0.745,
    ry: 0.692,
    fill: "#0085FF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.511,
    cy: 7.97,
    rx: 0.745,
    ry: 0.692,
    fill: "#0085FF"
  })));
};

export default SvgComment;